<template>
    <div>
        <b-modal :id= "'modal-accepterror' + status" ok-only title="Error" ok-title="OK">
            Please enter a delivery date before accepting order
        </b-modal>

        <b-container fluid>
            <transition name="fade">
            <div v-if="markingOrder" class="loading">
                <p>Marking order...</p>
            </div>
            </transition>
                <transition name="fade">
                    <div v-if="showAnimation" class="loading">
                        <p>{{animationTitle}}</p>
                    </div>
                </transition>
                <!-- New orders -->
                <b-row>
                        <b-col>
                            <b-pagination  size="sm"
                                v-model="currentPage"
                                :total-rows="totalLength"
                                :per-page="perPage"
                                first-text="First"
                                prev-text="Prev"
                                next-text="Next"
                                last-text="Last"
                            ></b-pagination>
                        </b-col>
                        <b-col>
                                <b-form-group  label-size="sm" 
                                    label-cols-sm="6"
                                    label="Per Page"
                                    label-align-sm="right"
                                    label-for="size"
                                    style="width:auto"
                                    >
                                    <b-form-select size="sm"
                                     style="width:auto"
                                    id="size"
                                    v-model="perPage"
                                    :options="pageOptions"
                                    ></b-form-select>
                                </b-form-group>
                        </b-col>
                </b-row>

            <b-row>
                <table class="table" style="margin-left:50px; margin-right:50px">
                      <thead class="thead-dark">
                        <tr>
                            <th>
                                <form v-if="sortingNewest">       
                                    <label v-b-tooltip.hover title="Sort by oldest orders" onmouseover="" style="cursor: pointer;" @click="sortOldest()">Date <font-awesome-icon icon="sort-numeric-up" /></label>
                                </form>
                                <form v-else>       
                                    <label v-b-tooltip.hover title="Sort by newest orders" onmouseover="" style="cursor: pointer;" @click="sortNewest()">Date <font-awesome-icon icon="sort-numeric-down" /></label>
                                </form>
                            </th>
                            <th>
                                <form>       
                                    <label v-b-tooltip.hover title="Sort by customer name" onmouseover="" style="cursor: pointer;" @click="sortCustomer()">Customer <font-awesome-icon icon="sort-alpha-up" /></label>
                                </form>
                            </th>
                            <th>
                                <form>       
                                    <label v-b-tooltip.hover title="Sort by beer name" onmouseover="" style="cursor: pointer;" @click="sortBeerName()">Beer <font-awesome-icon icon="sort-alpha-up" /></label>
                                </form>
                            </th>
                            <th v-if='status==0'>
                                <form>       
                                    <label>Delivery Date </label>
                                </form>
                            </th>
                            <th v-if='status==1'>
                                <form>       
                                    <label v-b-tooltip.hover title="Sort by delivery date" onmouseover="" style="cursor: pointer;" @click="sortDeliveryAsc()">Delivery Date <font-awesome-icon icon="sort-numeric-up" /></label>
                                </form>
                            </th>
                            <th v-if='status==-1||status==2'>Status</th>
                            <th>Actions</th>
                            <th>Select for Invoicing</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- Scroll over paginated display array -->
                            <template v-for="(item) in getDisplayArray">
                                <!-- Check if this order was edited and waiting for buyer to accept -->
                                <tr v-if="item.suggestedstatus==1" :key="item.suborderid+'edited'">
                                    <td colspan='12'>
                                        <strong style="color:red">Original Order: {{item.beerName}}. Waiting for buyer to accept the change</strong>
                                    </td>
                                </tr>
                                <tr :key='item.suborderid'>
                                <td>
                                    <h4>{{item.dateObject.date}}</h4>
                                    <h6>{{item.dateObject.month}}</h6>
                                </td>
                                <td  style="cursor:pointer;" v-b-modal="'buyerprofile' + item.suborderid" >
                                    <h5 class='breweryname'>{{item.pub}}</h5> {{item.deliveryAddress}}

                                </td>
                                <!-- Buyer Profile -->
                                <b-modal no-fade  scrollable size="xl" :id="'buyerprofile' + item.suborderid"  :title="item.pub" ok-only ok-variant="secondary" ok-title="Close" hide-footer>
                                    <buyerprofile  :buyerId="item.pubid" />
                                </b-modal>

                                <td>
                                    <!-- If rep, show brewery name -->
                                    <h5 class='breweryname' v-if='userProfile.isbrewer==10'>{{item.brewer}}</h5>
                                    <!-- Item details -->

                                    <!-- Check if item edited. If edited, show suggested -->
                                    <div v-if="item.suggestedstatus==1">
                                        <h6>Qty: {{item.orderQuantity}}</h6>
                                        <h6 style="color:#2e5189">{{item.suggestedbeername}}</h6>
                                        <h6>{{item.suggestedsize}}</h6>
                                        <div style='color:green'>
                                            <h6>${{item.suggestedcost}}</h6>
                                        </div>
                                    </div>

                                    <!-- Not edited. Show original order -->
                                    <div v-else>
                                        <h6>Qty: {{item.orderQuantity}}</h6>
                                        <h6 style="color:#2e5189">{{item.beerName}}</h6>
                                        <div v-if='item.multiSize==1'>
                                            <h6>{{item.size}}</h6>

                                        </div>
                                        <div class='graytext'>
                                        <div style='color:green'>
                                            <h6>${{item.totalCost}}</h6>
                                        </div>
                                        </div>
                                    </div>
                                </td>

                                <td v-if='status==0||status==1'>
                                    <div>
                                        <b-form-datepicker size="sm" :id="item.suborderid" value-as-date  v-model="item.deliveryTime" class="mb-2"></b-form-datepicker>
                                    </div>
                                    <div v-if="item.desiredDate" style='color:green; width:150px'>
                                        <small v-if='status==0'>Buyer requested {{item.deliveryTime}} delivery date</small>
                                    </div>

                                </td>
                                <td v-else-if='item.status==2'>{{item.displayStatus}}</td>
                                <td v-else-if='item.status==-1'>
                                    <div style='color:red'>
                                    <h5>{{item.displayStatus}}</h5>
                                    {{item.cancelMessage}}
                                    </div>
                                </td>

                                <!-- Actions for order -->
                                <td>
                                    <!-- Accept order -->
                                    <b-button-group>
                                    <b-button :disabled="item.suggestedstatus==1" v-b-modal="'Acceptorder' + item.suborderid"  v-if='status==0' v-b-tooltip.hover title="Accept Order" class="btn btn-success action-buttons"><i><font-awesome-icon icon="check" /></i></b-button>
                                    <!-- Accept order modal -->
                                    <b-modal :id="'Acceptorder' + item.suborderid" title="Cancel Order" 
                                        ok-title ='Yes, Accept Order' cancel-title ='Cancel'  @ok="acceptOrder(item.suborderid, item.deliveryTime, item.pubid, item.beerName, item.pub, item)" >
                                        <p class="my-4">Accept Order for {{item.orderQuantity}} {{item.beerName}} from {{item.pub}}?</p>
                                    </b-modal>

                                    <!-- Delivery date -->
                                    <b-button v-if='status==1' v-b-tooltip.hover title="Update Date" @click="updateDeliveryDate(item.suborderid, item.deliveryTime, item.pubid, item.beerName, item.pub, item)" class="btn btn-warning action-buttons"><i><font-awesome-icon icon="calendar" /></i></b-button>
                                    
                                    <!-- Edit order, only if open and not edited already -->
                                    <b-button v-if='status==0&&!(item.suggestedstatus==1)' v-b-modal="'Editorder' + item.suborderid" v-b-tooltip.hover title="Edit Order" 
                                        class='btn btn-info action-buttons'><i><font-awesome-icon icon="edit" /></i>
                                    </b-button>
                                    <!-- Edit order modal -->
                                    <b-modal :no-close-on-backdrop='true' size="xl" :id="'Editorder' + item.suborderid" title="Edit Order"  :hide-footer="true">
                                        <editorder :theOrder="item" @closeEditModal="closeEditModal" />
                                    </b-modal>
                                    
                                    <!-- Cancel order -->
                                    <b-button v-if='status==0||status==1' v-b-modal="'Cancelorder' + item.suborderid" v-b-tooltip.hover title="Cancel Order" 
                                        class='btn btn-danger action-buttons'><i><font-awesome-icon icon="times" /></i>
                                    </b-button>
                                    <!-- Cancel order modal -->
                                    <b-modal :id="'Cancelorder' + item.suborderid" title="Cancel Order" 
                                        ok-title ='Yes, Cancel Order'  :ok-disabled='!cancelMessage' cancel-title ='Do Not Cancel Order'  @ok="cancelOrder(item.suborderid, item.pubid, item.beerName, item.pub, item)">
                                        <p class="my-4">Cancel Order?</p>
                                        <textarea class="form-control"  v-model.trim="cancelMessage" type="text" placeholder="Please enter a reason for cancelling this order"> </textarea>
                                    </b-modal>

                                    <!-- Send message -->
                                    <b-button size="lg" v-b-modal="'SendMsg' + item.suborderid" v-b-tooltip.hover :title="'Message '+item.pub" 
                                        class='btn btn-primary action-buttons'><i><font-awesome-icon icon="comment" /></i>
                                    </b-button>

                                    <!-- Send message modal -->
                                    <b-modal size="lg" :id="'SendMsg' + item.suborderid" title="Send a Message"  hide-footer>
                                        <div class='col-12'>
                                            <sendmessage  :receiverId="item.pubid" :receiverName = "item.pub" :arrayDefaultMessages="arrayDefaultMessages"/>
                                        </div>
                                    </b-modal>

                                    <!-- Mark shipped -->
                                    <b-button  :disabled="item.suggestedstatus==1" v-if='status==1' v-b-modal="'MarkShipped' + item.suborderid"  v-b-tooltip.hover title="Mark Shipped" class='btn btn-success action-buttons'><i><font-awesome-icon icon="truck" /></i></b-button>
                                    <b-modal :id="'MarkShipped' + item.suborderid" title="Mark Shipped" 
                                        ok-title ='Yes, Mark As Shipped'  @ok="markShipped(item.suborderid, item.pubid, item.beerName, item)" >
                                        <p class="my-4">Mark this order as shipped?</p>
                                    </b-modal>

                                    <!-- Mark paid -->
                                    <b-button v-if='status==2&&item.paid!=1' v-b-modal="'MarkPaid' + item.suborderid"  v-b-tooltip.hover title="Mark Paid" class='btn btn-success action-buttons'><i><font-awesome-icon icon="dollar-sign" /></i></b-button>
                                    <b-modal :id="'MarkPaid' + item.suborderid" title="Mark Paid" 
                                        ok-title ='Yes, Mark As Paid'  @ok="markPaid(item.suborderid)" >
                                        <p class="my-4">Mark this order as paid?</p>
                                    </b-modal>

                                    <!-- Forward order to another email -->
                                    <b-button v-b-modal="'ForwardOrder' + item.suborderid" v-b-tooltip.hover title="Forward order to another email address" 
                                        class='btn btn-info action-buttons'><i><font-awesome-icon icon="share" /></i>
                                    </b-button>
                                    <!-- Modal to enter email address to forward to -->
                                    <b-modal :id="'ForwardOrder' + item.suborderid" title="Forward Order to Email" 
                                        ok-title ='Forward This Order'  @ok="forwardOrder(item)" >
                                        <p class="my-4">Forward this order to another email address?</p>
                                        <p class="my-4">Enter only ONE email address</p>
                                        <b-input-group prepend="Email Address" class="mt-3">
                                            <b-form-input v-model="forwardEmailAddress"></b-form-input>
                                        </b-input-group>
                                    </b-modal>
                                    
                                    <!-- Modal to check valid email id-->
                                    <b-modal :id= "'invalidEmail' + item.suborderid" ok-only title="Invalid Email Address" ok-title="OK">
                                        Please check the email address you entered
                                    </b-modal>

                                    <!-- Mail sent confirmation-->
                                    <b-modal :id= "'forwardConfirmation' + item.suborderid" ok-only title="Order Forwarded" ok-title="OK">
                                        The order from {{item.pub}} has been forwarded to {{forwardEmailAddress}}
                                    </b-modal>

                                    </b-button-group>
                                </td>
                                <!-- Invoice -->
                                <!-- If not invoiced before -->
                                <td v-if="!item.invoiced">
                                    <b-button v-if="!item.selected" variant="outline-secondary" @click="setOrderSelected(item)" style="height:40px; width:40px">
                                    </b-button>
                                    <b-button v-else variant="outline-secondary"  style="height:40px; width:40px" @click="setOrderUnselected(item)">
                                        <font-awesome-icon icon="check-square" />
                                    </b-button>
                                </td>
                                <!-- If already invoiced -->
                                <td v-else>
                                    <small>Invoice Number <br> {{item.invoicenumber}}</small>
                                    <br>
                                    <b-button variant="outline-secondary" @click="showInvoiceNumber(item.invoicenumber)">
                                        Show Invoice
                                    </b-button>
                                    <br>

                                    <b-button v-if="!item.selected" variant="outline-secondary" @click="setOrderSelected(item)"  style="height:40px; width:40px; margin-top:10px">
                                    </b-button>
                                    <b-button v-else variant="outline-secondary" @click="setOrderUnselected(item)"  style="height:40px; width:40px; margin-top:10px">
                                        <font-awesome-icon icon="check-square" />
                                    </b-button>
                                    <span style="margin-left:20px; padding-top:20px">Recreate</span>
                                </td>
                                </tr>
                                <!-- Buyer note -->
                                <tr v-if="item.buyerNote" :key='item.suborderid + "notekey" '>
                                    <td colspan="12">
                                        <div style="color:green">Note from <strong> {{item.pub}}</strong>:</div> <i> {{item.buyerNote}}</i>
                                    </td>
                                </tr>
                                
                            </template>
                        </tbody>

                </table>
            </b-row>
                                                
        </b-container>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    const fb = require('../firebaseConfig.js')
    import Sendmessage from './Sendmessage'
    import Editorder from './seller/Editorder'
    import Buyerprofile from './Buyerprofile'
    import {cancelorderupdateinventory} from './Myfunctions'
    import {timeConverterDateOnly} from './Myfunctions'
    import {sendnotification} from './Myfunctions'
    import Pagefooter from './Pagefooter.vue'
    
    export default {
        props: ['ordersArray', 'status', 'addToInvoicesArray', 'removeFromInvoicesArray'],
        components: {
            Sendmessage,
            Buyerprofile,
            Editorder,
            Pagefooter
            },
        computed: {
            ...mapState(['userProfile', 'currentUser']),
            getDisplayArray: function () {
                
                var localDisplayArray

                if(this.sortingNewest||this.sortingOldest||this.sortingCustomer||this.sortingDeliveryAsc||this.sortingDeliveryDesc||this.sortingBeerName){
                    localDisplayArray = this.displayArray
                }

                else localDisplayArray = this.ordersArray

                var paginatedList = []
                this.totalLength = localDisplayArray.length
                var indexStart = (parseInt(this.currentPage-1))*parseInt(this.perPage)
                var indexStop = indexStart + parseInt(this.perPage)

                if (indexStop>localDisplayArray.length) indexStop = localDisplayArray.length
                for (var k = indexStart; k<indexStop; k++){
                    paginatedList.push(localDisplayArray[k])
                }

                //console.log(paginatedList)
                return paginatedList
            }
        },

        data() {
            return {
                arrayDefaultMessages:[],
                cancelMessage:'',
                markingOrder:false,
                currentPage:1,
                perPage:10,
                totalLength:'',
                pageOptions: [
                    { value: '10', text: '10' },
                    { value: '25', text: '25' },
                    { value: '50', text: '50' },
                    { value: '9999999999999', text: 'All' },
                    ],
                deliveryOptions:[
                    'Self',
                    'Brown Bag',
                    'CBG',
                    'Crest',
                    'Scout',
                    'Southern',
                    'Stone',
                    'Wine Warehouse',
                    ],
                deliveryMethod:'',
                otherDeliveryMethod:'',
                sortingNewest:false,
                sortingOldest:false,
                sortingCustomer:false,
                sortingDeliveryAsc:false,
                sortingDeliveryDesc: false,
                sortingBeerName:false,
                displayArray:[],
                showAnimation:false,
                animationTitle:'',
                forwardEmailAddress:'', //Email address to forward order to
                
            }
        },
        methods: {
            acceptOrder(suborderid, deliveryDate, pubId, beerName, pub, order){
                if(!deliveryDate) {
                    this.$bvModal.show("modal-accepterror"+ this.status)
                    return
                }

                var nowDate = new Date()
                var lastUpdated = nowDate.getTime()

                this.markingOrder = true
                fb.ordersCollection.where('suborderid', '==', suborderid).get().then(docs => {
                docs.forEach(doc => {
                    fb.ordersCollection.doc(doc.id).update({
                        status: 1,
                        acceptedOn: nowDate,
                        deliveryDate:deliveryDate,
                        lastUpdated:lastUpdated,
                        acceptedbyuid:this.currentUser.uid,
                        acceptedbyemail:this.currentUser.email,
                    })
                    this.markingOrder = false

                // Add to news feed
                    var feedString
                    var feedObject = {}
                    feedObject.brewerId = this.currentUser.uid
                    feedObject.pubId = pubId
                    feedString = this.userProfile.company + ' Accepted order for: ' + beerName + ' from ' + pub
                    feedObject.feedString = feedString
                    this.$store.dispatch('addToNewsFeed',feedObject)

                    //Send email to pub
                    var subject = this.userProfile.company + ' accepted order for ' + beerName
                    var text = this.userProfile.company +' will deliver ' + beerName + ' on ' + timeConverterDateOnly(deliveryDate/1000)

                    //Fire notification
                    sendnotification(pubId, feedString)


                    })
                })
                .catch(err => {
                    console.log(err)
                })

            },

            cancelOrder(suborderid, pubId, beerName, pub, order){
                cancelorderupdateinventory(suborderid, 0, this.cancelMessage)
                //Send email to pub
                    var subject = this.userProfile.company + ' cancelled order for ' + beerName
                    var text = this.userProfile.company +' cancelled your order for ' + beerName + ' because ' + this.cancelMessage

                // Add to news feed
                    var feedString
                    var feedObject = {}
                    feedObject.brewerId = this.currentUser.uid
                    feedObject.pubId = pubId
                    feedString = this.userProfile.company + ' cancelled ' + beerName  + ' from ' + pub + ' Because: ' + this.cancelMessage
                    feedObject.feedString = feedString
                    this.$store.dispatch('addToNewsFeed',feedObject)
                    
                    //Fire notification
                    sendnotification(pubId, feedString)


                this.cancelMessage=''
            },
            updateDeliveryDate(suborderid, newDeliveryDate, pubId, beerName, pub, order){
                if(!newDeliveryDate) {
                    this.$bvModal.show("modal-accepterror"+ this.status)
                    this.warningNoDeliveryDataOnUpdate = true
                        this.$bvToast.toast('Please enter a delivery date first', {
                        title: 'Update Error!',
                        solid:true,
                        variant: 'danger',
                        autoHideDelay: 10000,
                        appendToast: false
                        })

                    return
                }
                else this.warningNoDeliveryDataOnUpdate = false
                var nowDate = new Date()
                var lastUpdated = nowDate.getTime()

                this.markingOrder = true
                fb.ordersCollection.where('suborderid', '==', suborderid).get().then(docs => {
                docs.forEach(doc => {
                    fb.ordersCollection.doc(doc.id).update({
                        deliveryDate:newDeliveryDate, lastUpdated:lastUpdated
                    })
                    this.$bvToast.toast('Order Updated', {
                        title: 'Keg Country',
                        solid:true,
                        variant: 'success',
                        autoHideDelay: 10000,
                        appendToast: false
                        })

                    this.markingOrder = false
                    //Send email to pub
                    var subject = this.userProfile.company + ' updated delivery date for ' + beerName
                    var text = this.userProfile.company +' will deliver ' + beerName + ' on ' + timeConverterDateOnly(newDeliveryDate/1000)

                // Add to news feed
                    var feedString
                    var feedObject = {}
                    feedObject.brewerId = this.currentUser.uid
                    feedObject.pubId = pubId
                    feedString = this.userProfile.company + ' Updated delivery date for ' + beerName + ' from ' + pub
                    feedObject.feedString = feedString
                    this.$store.dispatch('addToNewsFeed',feedObject)

                    //Fire notification
                    sendnotification(pubId, feedString)
                })
                }).catch(err => {
                console.log(err)
                })

            },
            markShipped(suborderid, pubId, beerName, order){
                this.markingOrder = true
                fb.ordersCollection.where('suborderid', '==', suborderid).get().then(docs => {
                docs.forEach(doc => {
                    var nowDate = new Date()
                    var lastUpdated = nowDate.getTime()
                    fb.ordersCollection.doc(doc.id).update({
                        status: 2,
                        shippedOn: new Date(),
                        lastUpdated:lastUpdated,
                    })
                    this.markingOrder = false
                    
                    // Add to news feed
                    var feedString
                    var feedObject = {}
                    feedObject.brewerId = this.currentUser.uid
                    feedObject.pubId = pubId
                    feedString = this.userProfile.company + ' shipped ' + beerName
                    feedObject.feedString = feedString
                    this.$store.dispatch('addToNewsFeed',feedObject)
                    //Send email to pub
                    var subject = this.userProfile.company + ' shipped ' + beerName
                    var text = this.userProfile.company +' has shipped your order for ' + beerName

                    //Fire notification
                    sendnotification(pubId, feedString)

                    })
                }).catch(err => {
                console.log(err)
                })
            },
            markPaid(suborderid){
                this.markingOrder = true
                fb.ordersCollection.where('suborderid', '==', suborderid).get().then(docs => {
                docs.forEach(doc => {
                    fb.ordersCollection.doc(doc.id).update({
                        paid:1
                    })
                    this.markingOrder = false
                })
                }).catch(err => {
                console.log(err)
                })
            },

            sortNewest(){
                this.showAnimation = true
                this.animationTitle="Sorting"
                setTimeout(() => { this.showAnimation = false }, 1500)
                this.displayArray = this.ordersArray
                this.currentPage = 1
                
                function compare(a, b) {
                    const costA = parseInt(a.createdOn.seconds)
                    const costB = parseInt(b.createdOn.seconds)
                    let comparison = 0;
                    if (costA <costB) {
                            comparison = 1;
                    } else if (costA>costB) {
                            comparison = -1;
                    }
                        return comparison;
                }
                this.displayArray.sort(compare);
                this.sortingNewest=true
                this.sortingOldest=false
                this.sortingCustomer=false
                this.sortingDeliveryAsc=false
                this.sortingDeliveryDesc=false
                this.sortingBeerName= false
            },
            sortOldest(){
                this.showAnimation = true
                this.animationTitle="Sorting"
                setTimeout(() => { this.showAnimation = false }, 1500)
                this.displayArray = this.ordersArray
                this.currentPage = 1
                
                function compare(a, b) {
                    const costA = parseInt(a.createdOn.seconds)
                    const costB = parseInt(b.createdOn.seconds)
                    let comparison = 0;
                    if (costA >costB) {
                            comparison = 1;
                    } else if (costA<costB) {
                            comparison = -1;
                    }
                        return comparison;
                }
                this.displayArray.sort(compare);
                this.sortingNewest=false
                this.sortingOldest=true
                this.sortingCustomer=false
                this.sortingDeliveryAsc=false
                this.sortingDeliveryDesc=false
                this.sortingBeerName= false
            },
            
            sortCustomer(){
                this.showAnimation = true
                this.animationTitle="Sorting"
                setTimeout(() => { this.showAnimation = false }, 1500)
                this.displayArray = this.ordersArray
                this.currentPage = 1
                function compare(a, b) {
                    var costA = a.pub.toUpperCase()
                    var costB = b.pub.toUpperCase()
                    let comparison = 0;
                    if (costA >costB) {
                            comparison = 1;
                    } else if (costA<costB) {
                            comparison = -1;
                    }
                        return comparison;
                }
                this.displayArray.sort(compare);
                this.sortingNewest=false
                this.sortingOldest=false
                this.sortingCustomer=true
                this.sortingDeliveryAsc=false
                this.sortingDeliveryDesc=false
                this.sortingBeerName= false
            },
            sortDeliveryDesc(){
                this.showAnimation = true
                this.animationTitle="Sorting"
                setTimeout(() => { this.showAnimation = false }, 1500)
                this.displayArray = this.ordersArray
                this.currentPage = 1
                
                function compare(a, b) {
                    const costA = parseInt(a.deliveryTime)
                    const costB = parseInt(b.deliveryTime)
                    let comparison = 0;
                    if (costA <costB) {
                            comparison = 1;
                    } else if (costA>costB) {
                            comparison = -1;
                    }
                        return comparison;
                }
                this.displayArray.sort(compare);
                this.sortingNewest=false
                this.sortingOldest=false
                this.sortingCustomer=false
                this.sortingDeliveryAsc=false
                this.sortingDeliveryDesc=true
                this.sortingBeerName= false
            },
            sortDeliveryAsc(){
                this.showAnimation = true
                this.animationTitle="Sorting"
                setTimeout(() => { this.showAnimation = false }, 1500)
                this.displayArray = this.ordersArray
                this.currentPage = 1
                
                function compare(a, b) {
                    const costA = parseInt(a.deliveryTime)
                    const costB = parseInt(b.deliveryTime)
                    let comparison = 0;
                    if (costA >costB) {
                            comparison = 1;
                    } else if (costA<costB) {
                            comparison = -1;
                    }
                        return comparison;
                }
                this.displayArray.sort(compare);
                this.sortingNewest=false
                this.sortingOldest=false
                this.sortingCustomer=false
                this.sortingDeliveryAsc=true
                this.sortingDeliveryDesc=false
                this.sortingBeerName= false
            },
            sortBeerName(){
                this.showAnimation = true
                this.animationTitle="Sorting"
                setTimeout(() => { this.showAnimation = false }, 1500)
                this.displayArray = this.ordersArray
                this.currentPage = 1
                function compare(a, b) {
                    var costA = a.beerName.toUpperCase()
                    var costB = b.beerName.toUpperCase()
                    let comparison = 0;
                    if (costA >costB) {
                            comparison = 1;
                    } else if (costA<costB) {
                            comparison = -1;
                    }
                        return comparison;
                }
                this.displayArray.sort(compare);
                this.sortingNewest=false
                this.sortingOldest=false
                this.sortingCustomer=true
                this.sortingDeliveryAsc=false
                this.sortingDeliveryDesc=false
                this.sortingBeerName= true
            },

            showBuyerProfile(buyerId){
                console.log("Showing profile for " + buyerId) 

            },
            sendNotification(uid, message){
                //var uid = "FXipitSRXEWCRjeHP0B9wuFvDpv1"
                //var message = "Notification message"
                sendnotification(uid, message)

            },

            //Select order for invoicing
            setOrderSelected(order){                
                //Update overall orders array
                const existingOrderindex = this.ordersArray.findIndex(item => item.suborderid === order.suborderid)
                var updatedOrder=this.ordersArray[existingOrderindex]
                updatedOrder.selected=1
                this.ordersArray.splice(existingOrderindex, 1, updatedOrder)

                //Update display array
                const existingDisplayOrderindex = this.displayArray.findIndex(item => item.suborderid === order.suborderid)
                if(existingDisplayOrderindex>-1){
                    var updatedDisplayOrder=this.displayArray[existingDisplayOrderindex]
                    updatedDisplayOrder.selected=1
                    this.displayArray.splice(existingDisplayOrderindex, 1, updatedDisplayOrder)
                }

                this.addToInvoicesArray(order)
            },
            //Unselect order from invoices array
            setOrderUnselected(order){
                //Update overall orders array
                const existingOrderindex = this.ordersArray.findIndex(item => item.suborderid === order.suborderid)
                var updatedOrder=this.ordersArray[existingOrderindex]
                updatedOrder.selected=0
                this.ordersArray.splice(existingOrderindex, 1, updatedOrder)

                //Update display array
                const existingDisplayOrderindex = this.displayArray.findIndex(item => item.suborderid === order.suborderid)
                if(existingDisplayOrderindex>-1){
                    var updatedDisplayOrder=this.displayArray[existingDisplayOrderindex]
                    updatedDisplayOrder.selected=0
                    this.displayArray.splice(existingDisplayOrderindex, 1, updatedDisplayOrder)
                }

                this.removeFromInvoicesArray(order)
            },

            //Show an invoice
            showInvoiceNumber(invoicenumber){
                this.$router.push({ path: 'showinvoice', query: { invoicenumber: invoicenumber }})
            },

            //Forward order to another email address
            forwardOrder(order){
                //Check of email is valid
                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(this.forwardEmailAddress))
                    {
                    }
                else{
                    this.$bvModal.show("invalidEmail" + order.suborderid)
                }
                var emailSubject = "Forwarded order for " + order.beerName + ' From ' + order.pub
                //Compose email

                    //Compose the email
                var emailhtml = "<html> <body><div>"+ "Thank you for ordering from Keg Seeker. Here is a summary of the order"
                emailhtml= emailhtml +'<hr>'
                emailhtml = emailhtml + "<div style='font-size:17px; color:#2B456E'>Brewery: " + order.brewer + "</div>"
                emailhtml = emailhtml + "<div style='font-size:17px; color:#2B456E'>Order From: " + order.pub + "</div>"
                emailhtml = emailhtml +"<hr>"
                emailhtml = emailhtml+ "<div style='font-size:15px;margin-left:50px'><strong>"+order.beerName + "</strong></div>"
                emailhtml = emailhtml+ "<div style='margin-left:50px'>"+order.size + "</div>"
                emailhtml = emailhtml+ "<div style='margin-left:50px'>Quantity: "+ order.orderQuantity + "</div>"
                emailhtml = emailhtml+ "<div style='margin-left:50px'>Cost: $ "+ order.cost + "</div>"
                //Add the rest of the fields
                emailhtml = emailhtml +"<hr>"


                emailhtml = emailhtml +"<div><strong>Delivery Address: "+order.deliveryAddress + "</strong></div>"
                emailhtml= emailhtml +'<hr>'
                //Add KS logo and link
                emailhtml = emailhtml + "<a href='https://www.kegseeker.com/'>"
                emailhtml = emailhtml + "<img src='https://res.cloudinary.com/lo4xxr5lr/image/upload/v1601714861/icons/KS_Blue_1_small.png'>"
                emailhtml = emailhtml + "</a>"

            //Add physical address
            emailhtml = emailhtml +"<br><div><small> Keg Seekers LLC, 325 W Washington St, Ste 2825, San Diego, CA 92103" + "</small></div>"
            
            //Close HTML
            emailhtml = emailhtml + "</div></body></html>"


                var mailData = {
                        to:this.forwardEmailAddress,
                        replyTo:this.currentUser.email,
                        from: this.userProfile.company +" <" + this.currentUser.email+">",
                        message:{
                            subject:emailSubject,
                            html:emailhtml,
                        }
                    }
                //Add to mail collection
                fb.mailCollection.add(mailData)
                this.$bvModal.show("forwardConfirmation" + order.suborderid)

            },

            //Suggest an order change
            changeOrder(item){
                console.log("Changing order")
            },

            //Close edit item modal
            closeEditModal(suborderid){
                this.$bvModal.hide("Editorder" + suborderid)
            }
            
        }
        
    }
</script>